<template>
  <FullScreenMap v-slot="{ fullScreen }">
    <Box :aspect="0.4" class="map-container mb-15" :class="{ '!h-screen !w-screen': fullScreen }">
      <ShowLocationMap
        :points="points"
        :show-info="true"
        :hide-inner-circle="true"
      >
        <template #info="{ point }">
          <h6>{{ point.name }}</h6>
          {{
            $t('pages.interestZoneList.map.infoWindowText', {
              multiplier: point.multiplier,
            })
          }}
        </template>
      </ShowLocationMap>
    </Box>
  </FullScreenMap>
</template>

<script lang="ts" setup>
import Box from '@components/utils/Box.vue';
import {
  computed,
} from 'vue';
import type { InterestZone } from '@/entities/Entities';
import ShowLocationMap from '@utils/maps/ShowLocationMap.vue';
import FullScreenMap from '@utils/FullScreenMap.vue';

interface Props {
  points?: InterestZone[];
}

const props = defineProps<Props>();
const points = computed(() => props.points?.map((point) => ({
  id: point.id,
  gisLocation: point.gisLocation,
  radius: point.radius,
  value: point.multiplier,
  name: point.name,
  multiplier: point.multiplier,
})));
</script>
